export const saveTextAsFile = (text) => {
  const blob = new Blob([text], { type: "text/plain" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "document.txt";
  link.click();
};
